import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	reportsTitle: {
		id: 'jsm.jsm-reports-common.reports-home-page.reports-title',
		defaultMessage: 'Reports',
		description: 'Title for the page',
	},
	searchPlaceholder: {
		id: 'jsm.jsm-reports-common.reports-home-page.search-placeholder',
		defaultMessage: 'Search for reports',
		description: 'Placeholder for searchbox',
	},
	dropdownTrigger: {
		id: 'jsm.jsm-reports-common.reports-home-page.dropdown-trigger',
		defaultMessage: 'Select a team',
		description: 'Dropdown trigger',
	},
	swithcToListViewButton: {
		id: 'jsm.jsm-reports-common.reports-home-page.switch-to-list-view-button',
		defaultMessage: 'Switch to list view',
		description: 'Button to switch to list view',
	},
	swithcToCardViewButton: {
		id: 'jsm.jsm-reports-common.reports-home-page.swithc-to-card-view-button',
		defaultMessage: 'Switch to card view',
		description: 'Button to switch to card view',
	},
	noAccessEmptyStateHeader: {
		id: 'jsm.jsm-reports-common.reports-home-page.no-access-empty-state-header',
		defaultMessage: 'Reports aren’t available',
		description: 'Empty State header',
	},
	noAccessEmptyStateDescription: {
		id: 'jsm.jsm-reports-common.reports-home-page.no-access-empty-state-description',
		defaultMessage:
			'It looks like you’ve not gained permission to reports yet. When your account admin adds you to reports, we’ll list them here.',
		description: 'Empty State description',
	},
	searchEmptyStateTitle: {
		id: 'jsm.jsm-reports-common.reports-home-page.search-empty-state-title',
		defaultMessage: 'We couldn’t find anything matching your search',
		description: 'Empty State title',
	},
	searchEmptyStateDescription: {
		id: 'jsm.jsm-reports-common.reports-home-page.search-empty-state-description',
		defaultMessage: 'Try again with a different term',
		description: 'Empty State title',
	},
});
